import type { RasterLayerSource } from '@/hooks/useDatasets';
import { releaseTilesPath } from './releaseTiles';
import type { LayerConfig } from './types';
import { LayerType } from './types';
import { TileLayer } from '@deck.gl/geo-layers';
import { BitmapLayer } from '@deck.gl/layers';
import { GL } from '@luma.gl/constants';
import { getGeoBoundingBox } from '@/views/map/utils';

export const getWildfireRiskLayer = (
  source: RasterLayerSource,
  config: LayerConfig,
  isOverview = true,
  minZoom = 5,
  maxZoom = 24
) => {
  const cmap = {
    '1': [200, 215, 181],
    '2': [255, 255, 116],
    '3': [255, 169, 0],
    '4': [255, 0, 0],
    '5': [168, 0, 0],
  };
  const cmap_param = encodeURIComponent(JSON.stringify(cmap));
  return new TileLayer({
    id: LayerType[LayerType.wildfire_risk],
    data: `${releaseTilesPath(source, 'png')}?pixel_selection=first&return_mask=true&bidx=1&resampling=nearest&colormap=${cmap_param}&tilesize=256`,
    loadOptions: {
      fetch: {
        credentials: 'include',
      },
    },
    minZoom,
    maxZoom,
    ...config,
    opacity: isOverview ? 0.25 : 0.15,
    refinementStrategy: 'no-overlap',
    renderSubLayers: (props) => {
      if (props.data === null) {
        return null;
      }

      const boundingBox = getGeoBoundingBox(props);
      if (!boundingBox) {
        return null;
      }
      const { west, south, east, north } = boundingBox;

      return new BitmapLayer({
        id: props.id,
        image: props.data,
        bounds: [west, south, east, north],
        textureParameters: {
          [GL.TEXTURE_MIN_FILTER]: GL.NEAREST,
          [GL.TEXTURE_MAG_FILTER]: GL.NEAREST,
        },
        transparentColor: [255, 255, 255, 0],
        pickable: props.pickable,
        opacity: props.opacity,
        visible: props.visible,
        highlightColor: props.highlightColor,
      });
    },
  });
};
